import * as React from 'react';
import { connect } from 'react-redux';
import Colors from '../styles/Colors.js';
import Fonts from '../styles/Fonts.js';

function TextEvents(props) {
    return <label style={
        {
            textAlign: props.align,
            display: props.styleDisplay ? props.styleDisplay : 'block',
            marginTop: 0, marginBottom: 0,
            marginRight: props.styleMargin ? props.styleMargin : 0,
            fontSize: Fonts.size[props.size],
            color: Colors[props.color],
            fontWeight: Fonts.weight[props.weight],
            paddingBottom: props.paddingB,
            width: props.labelWidth
        }}>{props.text}</label>
}

export default connect()(TextEvents);